import config from '../../config/environment';
import { withRequestIdHeaders } from '../../utils/requestId';
import {
  CHECKOUT_ACTION_QUERY_PARAM,
  CHECKOUT_CHARGE_QUERY_PARAM,
  CHECKOUT_PLAN_QUERY_PARAM,
  CHECKOUT_REF_QUERY_PARAM,
} from './checkout.constants';
import { mapProjectIdentity } from '../../utils/project';
import type { CheckoutSelectedPlan } from './checkout.types';

const LEGACY_CHECKOUT_PLAN_QUERY_PARAM = 'plano';

interface CheckoutPlanResponse {
  success?: boolean;
  data?: {
    plan?: CheckoutSelectedPlan;
  };
  error?: {
    message?: string;
  };
}

export const parseCheckoutPlanHashFromUrl = (searchParams: URLSearchParams): string | null => {
  const rawValue = searchParams.get(CHECKOUT_PLAN_QUERY_PARAM)?.trim()
    ?? searchParams.get(LEGACY_CHECKOUT_PLAN_QUERY_PARAM)?.trim();

  if (!rawValue) {
    return null;
  }

  return rawValue;
};

export const parseCheckoutActionHashFromUrl = (searchParams: URLSearchParams): string | null => {
  const rawValue = searchParams.get(CHECKOUT_ACTION_QUERY_PARAM)?.trim();

  if (!rawValue) {
    return null;
  }

  return rawValue;
};

export const parseCheckoutChargeTokenFromUrl = (searchParams: URLSearchParams): string | null => {
  const rawValue = searchParams.get(CHECKOUT_CHARGE_QUERY_PARAM)?.trim();

  if (!rawValue) {
    return null;
  }

  return rawValue;
};

export const parseCheckoutRefTokenFromUrl = (searchParams: URLSearchParams): string | null => {
  const rawValue = searchParams.get(CHECKOUT_REF_QUERY_PARAM)?.trim();
  return rawValue || null;
};

export const isCheckoutTrackingRefError = (message: string): boolean => (
  /referência de projeto inválida/i.test(message)
  || /link rastreável válido/i.test(message)
);

export const resolveCheckoutPlan = async (
  planHash: string,
): Promise<CheckoutSelectedPlan> => {
  const response = await fetch(`${config.supabaseFunctionsUrl}/students`, {
    method: 'POST',
    headers: withRequestIdHeaders({
      'Content-Type': 'application/json',
      apikey: config.supabaseAnonKey,
      Authorization: `Bearer ${config.supabaseAnonKey}`,
    }),
    body: JSON.stringify({
      action: 'checkout',
      payload: {
        previewOnly: true,
        selectedPlan: {
          hash: planHash,
        },
      },
    }),
  });

  const body = await response.json().catch(() => ({})) as CheckoutPlanResponse;

  if (!response.ok || body.success === false || !body.data?.plan) {
    throw new Error(body.error?.message || 'Invalid checkout plan.');
  }

  return {
    ...body.data.plan,
    project: mapProjectIdentity(body.data.plan.project),
  };
};
